module.exports = __webpack_public_path__ + "icons/original/large/large-d5.93f0c9556e78c0b2b5ab5a7bb293e22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-d5.png
// module id = 1Tjk
// module chunks = app